import React, { useState, useEffect, useMemo } from 'react';
import { tupoksiService } from '../../services/tupoksiService';
import { FaSpinner, FaExclamationTriangle } from 'react-icons/fa';

const Tupoksi = () => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [selectedId, setSelectedId] = useState('all');
    const [error, setError] = useState('');

    useEffect(() => {
        loadData();
    }, []);

    const loadData = async () => {
        setLoading(true);
        const result = await tupoksiService.getPublicTupoksi();
        if (result.success) {
            setData(result.data?.data || result.data || []);
        } else {
            setError(result.message);
        }
        setLoading(false);
    };

    const filteredData = useMemo(() => {
        if (selectedId === 'all') return data;
        return data.filter(item => item.id === parseInt(selectedId));
    }, [selectedId, data]);

    const options = [
        { value: 'all', label: '-- Semua Jabatan --' },
        ...data.map(item => ({
            value: item.id,
            label: item.jabatan
        }))
    ];

    // Ambil dasar hukum dari data pertama
    const dasarHukum = data.find(item => item.dasar_hukum)?.dasar_hukum;

    if (loading) {
        return (
            <div className="container mx-auto px-4 py-12 text-center">
                <FaSpinner className="animate-spin text-4xl text-[#2E7D32] mx-auto mb-4" />
                <p className="text-gray-500">Memuat data...</p>
            </div>
        );
    }

    if (error || data.length === 0) {
        return (
            <div className="container mx-auto px-4 py-12">
                <div className="card-glass text-center py-12">
                    <FaExclamationTriangle className="text-5xl text-yellow-500 mx-auto mb-4" />
                    <h2 className="text-xl font-bold text-gray-700 mb-2">Data Belum Tersedia</h2>
                    <p className="text-gray-500">
                        {error || 'Data tupoksi belum diinput oleh admin'}
                    </p>
                </div>
            </div>
        );
    }

    return (
        <div className="container mx-auto px-4 py-12">
            <h1 className="text-3xl md:text-4xl font-bold text-[#0F4C3A] mb-2">
                Tugas Pokok dan Fungsi
            </h1>
            {dasarHukum && (
                <p className="text-gray-600 mb-6">
                    Berdasarkan {dasarHukum}
                </p>
            )}

            {/* Dropdown filter */}
            <div className="mb-8 max-w-md">
                <label htmlFor="filter-jabatan" className="block text-sm font-medium text-gray-700 mb-1">
                    Pilih Jabatan
                </label>
                <select
                    id="filter-jabatan"
                    value={selectedId}
                    onChange={(e) => setSelectedId(e.target.value)}
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#2E7D32] outline-none"
                >
                    {options.map((opt) => (
                        <option key={opt.value} value={opt.value}>
                            {opt.label}
                        </option>
                    ))}
                </select>
            </div>

            <p className="text-sm text-gray-500 mb-4">
                Menampilkan {filteredData.length} dari {data.length} jabatan
            </p>

            <div className="space-y-8">
                {filteredData.length === 0 ? (
                    <div className="text-center py-12">
                        <p className="text-gray-500 text-lg">Tidak ada data yang sesuai.</p>
                    </div>
                ) : (
                    filteredData.map((item) => (
                        <div
                            key={item.id}
                            className="bg-white rounded-xl shadow-lg overflow-hidden border-l-4 border-[#2E7D32] hover:shadow-xl transition-shadow duration-300"
                        >
                            <div className="p-6">
                                <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-4">
                                    <h2 className="text-2xl font-bold text-[#2E7D32]">
                                        {item.jabatan}
                                    </h2>
                                    <span className="text-sm bg-green-50 text-[#0F4C3A] px-3 py-1 rounded-full font-medium">
                                        {item.tingkat}
                                    </span>
                                </div>

                                <div className="mb-4">
                                    <h3 className="text-lg font-semibold text-[#0F4C3A] mb-2">
                                        Tugas:
                                    </h3>
                                    <p className="text-gray-700 leading-relaxed">{item.tugas}</p>
                                </div>

                                <div>
                                    <h3 className="text-lg font-semibold text-[#0F4C3A] mb-2">
                                        Uraian Tugas:
                                    </h3>
                                    <ol className="list-decimal list-inside space-y-1 text-gray-700 leading-relaxed">
                                        {item.uraian_tugas?.map((point, idx) => (
                                            <li key={idx} className="pl-2">
                                                {point}
                                            </li>
                                        ))}
                                    </ol>
                                </div>
                            </div>
                        </div>
                    ))
                )}
            </div>
        </div>
    );
};

export default Tupoksi;